// 168 Kib
import Echo from 'laravel-echo' // 11 Kib (179 Kib)

window.io = require('socket.io-client'); // 96 Kib (275 Kib)

let echoConfig = {
    broadcaster: 'socket.io',
    host: `${window.echoConfig.host}:${window.echoConfig.port}`,
    path: `${window.echoConfig.path}`
    // host: 'http://localhost:6001'
    // host: 'membre-dev-v2-echo.localhost:80'
};

window.Echo = new Echo( echoConfig );

// console.log('echoConfig', echoConfig);
// console.log('window.echoConfig', window.echoConfig);
// console.log('Echo', window.Echo);

if ( window.echoConfig.host != null
    && window.echoConfig.mem_id != null )
{
    window.Echo.private(`notification.message.${window.echoConfig.mem_id}`) // *
    .listen('MessagerieNew', function (e)
    {
        // doStuff
        console.log('MessagerieNew', e);
        // window.livewire.emit('notification.message');
        // console.log('notification.message');

        /*
        if (e.notification_link != window.location.pathname)
        {

        }
        */
        displayNotif({
            body: e.notification,
            href: e.notification_link,
        });
    });

    window.Echo.private(`notification.flash.${window.echoConfig.mem_id}`)
    .listen('FlashNew', function (e)
    {
        // doStuff
        console.log('FlashNew', e);
        // window.livewire.emit('notification.flash');
        // console.log('notification.flash');

        displayNotif({
            body: e.notification,
            href: e.notification_link,
        });
    });
    window.Echo.private(`notification.visite.${window.echoConfig.mem_id}`)
    .listen('VisiteNew', function (e)
    {
        // doStuff
        console.log('VisiteNew', e);
        // window.livewire.emit('notification.visite');
        // console.log('notification.visite');

        displayNotif({
            body: e.notification,
            href: e.notification_link,
        });
    })


    window.Echo.join(`chat`)
        .here((users) => {
            console.log('here users', users)
        })
        .joining((user) => {
            console.log('joining user.name', user.name);
        })
        .leaving((user) => {
            console.log('leaving user.name', user.name);
        })
        .listen('NewMessage', (e) => {
            console.log('NewMessage e', e);
        })
    ;

    // console.log('Echo private', `App.User.${window.echoConfig.mem_id}`)
    // window.Echo
    // .private(`App.User.${window.echoConfig.mem_id}`)
    // .listen('MessagerieNew', (e) => {
    //         console.log('MessagerieNew > e', e);
    //         debugger;
    //     });
    // window.Echo
    //     .channel(`App.User.${window.echoConfig.mem_id}`)
    //     .listen('MessagerieNew', (e) => {
    //             console.log('MessagerieNew > e', e);
    //             debugger;
    //         });


    // console.log('Echo private', `private-App.User.${window.echoConfig.mem_id}`)
    // window.Echo
    // .private(`private-App.User.${window.echoConfig.mem_id}`)
    //     .listen('MessagerieNew', (e) => {
    //         console.log('MessagerieNew > e', e);
    //         debugger;
    //     });
    // window.Echo
    //     .private('notification.1')
    //     .listen('MessagerieNew', (payload) => {
    //         console.log(payload);
    //     });
        /*
    console.log('Echo private', `Test`)
    window.Echo
        .private(`Test`)
        .listen('MessagerieNew', (e) => {
            console.log('MessagerieNew > e', e);
            debugger;
        });
        */
    // window.Echo
    //     .channel('test')
    //     .listen('Test', (e) => {
    //         console.log(e);
    //     });
}
// window.Echo.join(`chat.${roomId}`)
/*
window.Echo.join(`chat`)
    .here((users) => {
        console.log('here users', users)
    })
    .joining((user) => {
        console.log('joining user.name', user.name);
    })
    .leaving((user) => {
        console.log('leaving user.name', user.name);
    })
    .listen('NewMessage', (e) => {
        console.log('NewMessage e', e);
    })
    ;
*/
